export const fileUploadElement = (el) => {
  const input = el.querySelector('.gfield--type-fileupload');
  const formFooter = el.querySelector('.gform_footer');
  if (!input) return;

  const button = document.createElement('button');
  const icon = document.createElement('i');

  const handleFiles = function (e) {
    // return a string with the number of files attached, e.g. 1 file attached, 2 files attached
    const fileCount = this.files.length;
    const fileCountString =
      fileCount === 1 ? '1 file attached' : `${fileCount} files attached`;

    if (fileCount > 0) {
      updateButtonText(fileCountString);
    } else {
      updateButtonText(input.querySelector('label').textContent);
    }
  };

  const updateButtonText = (label) => {
    button.textContent = label;
    button.prepend(icon);
  };

  button.classList.add(
    'self-start',
    '!mb-4',
    'lg:mb-0',
    'uppercase',
    'text-black',
    'text-[clamp(16px,1.875vw,24px)]',
    'opacity-40',
    'hover:opacity-100',
  );
  icon.classList.add('fa-light', 'fa-paperclip', 'mr-4', 'lg:mr-8');

  input
    ?.querySelector('input[type="file"]')
    .addEventListener('change', handleFiles);

  button.addEventListener('click', (e) => {
    e.preventDefault();
    input.querySelector('input[type="file"]').click();
  });

  updateButtonText(input.querySelector('label').textContent);
  input.classList.add('hidden');
  formFooter.prepend(button);
};

export default fileUploadElement;
